// extracted by mini-css-extract-plugin
export default {"container":"RegistrationProgress_container__Y02hX"};